<template>
  <div>
    <!-- <h1> -->
    <!--   <img -->
    <!--     src="@/assets/images/en/tendersound.png" -->
    <!--     class="image-title" -->
    <!--   /> -->
    <!-- </h1> -->
    <div class="text pause">
      <img src="@/assets/biomes/biome1/instructions.png">
      <h1>Make some noise!</h1>
      <p>
        Make sure your computer's microphone is switched on.<br>
        At this stage of the game, interaction is acoustic.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenderSoundEn'
}
</script>

<style scoped src="@/assets/css/menus.css" />
